"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DialogViewportDataAttributes = void 0;
var _popupStateMapping = require("../../utils/popupStateMapping");
let DialogViewportDataAttributes = exports.DialogViewportDataAttributes = function (DialogViewportDataAttributes) {
  /**
   * Present when the dialog is open.
   */
  DialogViewportDataAttributes[DialogViewportDataAttributes["open"] = _popupStateMapping.CommonPopupDataAttributes.open] = "open";
  /**
   * Present when the dialog is closed.
   */
  DialogViewportDataAttributes[DialogViewportDataAttributes["closed"] = _popupStateMapping.CommonPopupDataAttributes.closed] = "closed";
  /**
   * Present when the dialog is animating in.
   */
  DialogViewportDataAttributes[DialogViewportDataAttributes["startingStyle"] = _popupStateMapping.CommonPopupDataAttributes.startingStyle] = "startingStyle";
  /**
   * Present when the dialog is animating out.
   */
  DialogViewportDataAttributes[DialogViewportDataAttributes["endingStyle"] = _popupStateMapping.CommonPopupDataAttributes.endingStyle] = "endingStyle";
  /**
   * Present when the dialog is nested within another dialog.
   */
  DialogViewportDataAttributes["nested"] = "data-nested";
  /**
   * Present when the dialog has other open dialogs nested within it.
   */
  DialogViewportDataAttributes["nestedDialogOpen"] = "data-nested-dialog-open";
  return DialogViewportDataAttributes;
}({});